"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLLUP_KEY_WORDS = void 0;
// reserved keyword: values are used to rollup the lookup field
exports.ROLLUP_KEY_WORDS = 'values';
//# sourceMappingURL=consts.js.map